
<template>
  <div class="supermor">
    <Headers></Headers>
    <div class="supermor-center">
      <img src="https://aliyunosszs.musicwow.com/APPimg/product/musicBg.png">
      <div class="center-body">
        <ul class="oneList">
          <li v-for="(item,idx) in navData" :key="idx">
            <img :src="item.cover">
            <div class="oneList-items">
              <div class="items-text">
                <p>{{item.title}}</p>
                <p>{{item.describe}}</p>
              </div>
              <div class="items-mor">
                <div class="mor-mon">
                  <span class="mon-text">￥</span>
                  <span class="mon-num">{{item.money}}元</span>
                </div>
                <div class="mor-det" @click="onSuperData(item.id)">
                  <span>课程详情</span>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Headers from '@/components/header.vue'
import Footer from '@/components/footer.vue'

export default {
  name: 'league',
  data () {
    return {  
      navData:[
        {
          imgUrl:'https://aliyunosszs.musicwow.com/APPimg/product/product(8).png',
          title:'TOMMY CHAN《全能职业吉他手》',
          text: '一句话描述一句话描述一句话描述',
          mon:'490',

        }
        ,
        {
          imgUrl:'https://aliyunosszs.musicwow.com/APPimg/product/product(9).png',
          title:'江建民《天才吉他手II》',
          text: '一句话描述一句话描述一句话描述',
          mon:'490',

        }
        ,
      ],
      listData: [],
    }
  },
  computed: {
  },
  components: {
    Headers,
    Footer
  },
  methods: {
    onMusicData(){
      this.$router.push({name: 'MusicwowDetails'});
    },
    onSuperData(id){
      
      localStorage.detailsId = id || localStorage.detailsId 
      this.$router.push({name: 'SuperBook',params:{ id:id}});
    },
    // onSuperMor(id){
      
    //   this.$router.push({name: 'SuperBook'});
    // },
    onMusicMor(){
      this.$router.push({name: 'SuperBook'});
    },
    async onSuperListData(){
      let productData= await this.$API.getProductData({type_id: 2})
      this.navData  = productData.data
    

    }
  },
  mounted () {
    
  },
  created () {
    this.onSuperListData()

  }
}
</script>
<style lang="sass" scoped>
.supermor
  .supermor-center
    padding-top: 60px
    img
      width: 100%
    .center-body
      margin: 20px 0
      .oneList
        margin: 20px
        li  
          padding: 12px 0

          .oneList-items
            padding: 10px
            box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.1)
            border-radius: 0px 0 4px 4px

            .items-text
              text-align: left
              padding-bottom: 30px
              padding-top: 10px
            .items-text>p:nth-child(1)
              font-size: 14px
              color: #1E1E1E
            .items-text>p:nth-child(2)
              font-size: 11px
              color: #979797
            .items-mor
              display: flex
              padding: 15px 0
              border-top: 1px solid #EDEDED

              .mor-mon
                color: #979797
                .mon-text
                  font-size: 10px
                .mon-num
                  font-size: 20px
              .mor-det
                margin-left: auto
                border-radius: 4px
                color: #fff
                font-size: 10px
                background: linear-gradient(137deg,rgba(32,210,200,1) 0%,rgba(7,209,170,1) 100%)
                padding: 5px
    
      





</style>

